// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__3cpWD","category":"styles_category__1ZW5o","categories":"styles_categories__2qY4_","articles":"styles_articles__d2syk","article":"styles_article__1JCz1"};